<template>
  <div class="app-promotion">
    <div class="panel-header">
      <h3 class="panel-header__title">推广管理</h3>
      <span class="panel-header__subtitle">PROMOTION MANAGEMENT</span>
    </div>
    <div class="panel-content">
      <h3 class="panel-content__title">推广管理</h3>
      <up-form class="panel-content__form" :model="form" :rules="rules" ref="form" label-width="130px" v-loading="loading" element-loading-text="加载中...">
        <up-form-item-select v-if="platform === 'agency'" label="所属广告主：" prop="advertiser_id" v-model="form.advertiser_id" :disabled="disabledField" :data="adUsers" placeholder="请选择所属广告主" @up:select:change="handleAdUserChange"></up-form-item-select>
        <up-form-item-input class="w364" label="推广名称：" prop="name" v-model="form.name" placeholder="请输入推广名称"></up-form-item-input>
        <up-form-item label="应用选择：" prop="app_id">
          <up-select class="mr20" popper-class="app-promotion__app-list" v-model="form.app_id" :data="apps" :key-value="['show_name', 'id']" placeholder="请选择应用名称" @up:select:change="handleAppChange" filterable>
            <template slot="up:item" slot-scope="{ item }">
              <div class="app-promotion__app-item">
                <img :src="item.icon"><span>{{item.show_name}}(版本号：{{item.version_num}} ID：{{item.id}})</span>
              </div>
            </template>
          </up-select>
          <up-button type="primary" @click="$router.push({ path: '/channel/add' })">上传应用</up-button>
        </up-form-item>
        <up-form-item label="总预算：" prop="total_budget">
          <up-input v-model="form.total_budget" placeholder="请输入总预算" @input.native="handleInputBudget('total_budget')"></up-input>
        </up-form-item>
        <up-form-item label="日预算：" prop="budget">
          <up-input v-model="form.budget" placeholder="请输入日预算" @input.native="handleInputBudget('budget')"></up-input>
        </up-form-item>
        <up-form-item label="出价：" prop="bidding">
          <up-input v-model="form.bidding" placeholder="请输入出价"></up-input>
          <span v-if="minBidding && avgBidding">（<span class="app-promotion__bidding">最低单价 {{minBidding}}元，建议单价 {{avgBidding}}元</span>）</span>
        </up-form-item>
        <up-form-item-radio label="计算类型：" prop="payment" v-model="form.payment" :data="payments" placeholder="请选择计算类型"></up-form-item-radio>
        <up-form-item label="推广周期：" prop="is_all_time">
          <up-radio-group v-model="form.is_all_time" :data="[{ name: '全时段', value: '1' }, { name: '特定时段', value: '0' }]"></up-radio-group>
        </up-form-item>
        <up-form-item prop="times" v-if="form.is_all_time === '0'">
          <dateRange2
            class="advertise-opr__date-range ml16"
            ref="date"
            page-info="advertise"
            :type24="false"
            :disabledType="true"
            :default-date="defaultDate"
            :receive-data="receiveData"
            :receive-date-range="receiveDateRange"
            :disabledTime="disabledTime"
            @selectedCycle="handleDateSelect"
          ></dateRange2>
          <span
            style="position: absolute; left: 224px; top: 0px; margin-left: 6px;"
            :style="form.times.length > 60 ? 'color: #F56C6C' : 'color: #909399'"
          >选择排期总天数最多只支持60天</span>
        </up-form-item>
        <div class="panel-content__btn-group">
          <template v-if="type !== 'view'">
            <div class="panel-content__btn"><up-button size="large" type="primary" @click="submitForm('form')">{{ !next ? btnText('保存') : '保存' }}</up-button></div>
            <div class="panel-content__btn"><up-button size="large" type="primary" @click="submitForm('form', true)">{{ next ? btnText('保存并创建新推广') : '保存并创建新推广' }}</up-button></div>
          </template>
          <div class="panel-content__btn"><up-button size="large" class="is-cancel" @click="$router.go(-1)">取消</up-button></div>
        </div>
      </up-form>
    </div>
  </div>
</template>

<script>
import { dateRange2 } from '@/global/components'
import { mapGetters, mapActions } from 'vuex'
import { comdify, delcommafy, availableDate, dataFilter } from '@/global/util/util'

export default {
  name: 'promotion-add',
  components: { dateRange2 },
  data () {
    const validatePromotionName = async (rule, value, callback) => {
      if (value === '') {
        callback(new Error('推广名称不能为空'))
      } else if (value.length > 50) {
        callback(new Error('推广名称不能超过50个字符'))
      } else {
        const [, res] = await this['promotion/validatePromotionName']({ value })
        if (
          res.data === 1 &&
          (
            ['add', 'copy'].includes(this.type) ||
            (this.type === 'edit' && this.originalPromotionName !== value)
          )
        ) {
          callback(new Error('推广名称已经存在'))
        } else {
          callback()
        }
      }
    }

    const validateBudget = (field) => (rule, value, callback) => {
      const label = field === 'total_budget' ? '总' : '日'
      if (value || value === '0') {
        if (delcommafy(value) < 100) {
          callback(new Error(`${label}预算最低100元`))
        } else if (delcommafy(value) > 10000000) {
          callback(new Error(`${label}预算不得超过10000000`))
        } else if (!/^[0-9]*[1-9][0-9]*$/.test(delcommafy(value))) {
          // this.form.budget = this.form.budget.replace(/[^\d]/g, '')
          callback(new Error(`${label}预算必须是正整数`))
        } else {
          callback()
        }
      } else {
        callback(new Error(`请输入${label}预算`))
      }
    }

    const validateBid = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入出价'))
      } else if (
        (value <= 0 && value > 100000000) ||
        !(value > 0 && value <= 100000000 && /^\d*(\.\d{1,2})?$/.test(value))
      ) {
        callback(new Error('出价不得超过100,000,000或精确两位小数'));
      } else if (this.minBidding && value < this.minBidding) {
        callback(new Error('出价不能低于最低出价'))
      } else {
        callback();
      }
    }

    this.payments = [
      { name: '按照下载计费', value: 'cpd' }
    ]

    return {
      platform: '',
      id: '',
      type: '',
      adUsers: [],
      apps: [],
      originalPromotionName: '',
      minBidding: '',
      avgBidding: '',
      form: {
        advertiser_id: '',
        name: '',
        app_id: '',
        app_name: '',
        total_budget: '',
        budget: '',
        bidding: '',
        payment: 'cpd',
        is_all_time: '',
        date: [],
        times: []
      },
      rules: {
        advertiser_id: [{ required: true, message: '请选择所属广告主', trigger: 'change' }],
        name: [{ required: true, validator: validatePromotionName, trigger: 'blur' }],
        app_id: [{ required: true, message: '请选择应用名称', trigger: 'change' }],
        total_budget: [{ required: true, type: 'number', validator: validateBudget('total_budget'), trigger: 'blur' }],
        budget: [{ required: true, type: 'number', validator: validateBudget('budget'), trigger: 'blur' }],
        bidding: [{ required: true, validator: validateBid, trigger: 'blur' }],
        payment: [{ required: true, message: '请选择计算类型', trigger: 'change' }],
        is_all_time: [{ required: true, message: '请选择时段类型', trigger: 'change' }],
        times: [{ type: 'array', required: true, message: '请选择投放时间', trigger: 'change' }]
      },
      defaultDate: [], // 日期 start
      receiveData: [],
      receiveDateRange: [],
      disabledTime: {}, // 日期 end
      submitted: false,
      submitting: false,
      verifying: false,
      next: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'login/user'
    }),
    btnText () {
      return function (text) {
        return this.submitting ? `${text}中...` : this.submitted ? `已${text}` : text
      }
    },
    disabledField () {
      return ['edit', 'view'].includes(this.type)
    }
  },
  watch: {
    'user.equal_to_account' (value) {
      if (this.platform === 'ad-user' && !this.apps.length) {
        this.handleAdUserChange(value)
      }
    }
  },
  methods: {
    ...mapActions([
      'promotion/getAdUsers',
      'promotion/validatePromotionName',
      'promotion/addAndUpdatePromotion',
      'promotion/getPromotionDetail',
      'channel/getChannelByAdId',
      'promotion/getPromotionBidding'
    ]),
    async getAdUsers () {
      const [err, res] = await this['promotion/getAdUsers']()
      if (err || res.code !== 1) this.$message.error('获取广告主列表失败')
      else {
        this.adUsers = res.code === 1 ? res.data : []
      }
    },
    // 获取应用选择列表
    async handleAdUserChange (id) {
      const [err, res] = await this['channel/getChannelByAdId'](id)
      if (err) { return this.$message.error('获取应用推广列表失败') }
      this.apps = res.data
    },
    async handleAppChange (value) {
      const app = this.apps.find(app => app.id === value)
      const [err, res] = await this['promotion/getPromotionBidding']({ appName: app.app_name })
      if (err) { return this.$message.error('获取出价失败') }
      if (res.data) {
        const { minBidding, avgBidding } = res.data
        this.minBidding = minBidding || '0.5'
        this.avgBidding = avgBidding || '0.6'
      } else {
        this.minBidding = '0.5'
        this.avgBidding = '0.6'
      }
    },
    handleInputBudget (field) {
      this.$nextTick(() => {
        if (this.form[field]) {
          this.form[field] = comdify(delcommafy(this.form[field]))
        }
      })
    },
    handleDateSelect ({ date, dateCycle }) {
      dateCycle = availableDate(dateCycle)

      this.receiveDate = date;
      this.receiveData = dataFilter(date);
      this.receiveDateRange = [...dateCycle];
      this.form.times = date
      this.form.date = [...dateCycle]
      if (date && date.length < 2 && date[0].time.length < 1) { // 处理当天都不可选情况
        this.form.date = []
      }
      this.$refs.form.validateField('times')

      if (date.length > 60) {
        this.$message.error('投放周期超过60天，请重新修改后再提交！')
      }
    },
    submitForm (formName, next) {
      if (this.verifying) return
      this.verifying = true
      if (this.submitted || this.submitting) return this.$message.error('请勿重复提交数据！')
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.next = next
          this.submitting = true
          this.verifying = false

          const text = this.type === 'edit' ? '修改' : this.type === 'copy' ? '复制' : '添加'
          const { budget, total_budget: totalBudget, date, times, ...formData } = this.form

          formData.total_budget = delcommafy(totalBudget)
          formData.budget = delcommafy(budget)

          if (this.platform !== 'agency') {
            formData.advertiser_id = this.user.equal_to_account
          }

          const app = this.apps.find(item => item.id === formData.app_id)
          if (app) {
            formData.app_name = app.app_name
          }

          if (formData.is_all_time === '0') {
            formData.date = date
            formData.times = times
          }

          const [err, res] = await this['promotion/addAndUpdatePromotion']({ type: this.type, id: this.id, params: formData })
          this.submitting = false
          if (err) return this.$message.error(`${text}推广失败`)
          else if (res.code !== 1) {
            return this.$message.error(res.msg)
          } else {
            this.submitted = true
            this.$message.success(`${text}推广成功`)

            if (!next) {
              setTimeout(_ => this.$router.push({ path: '/promotions' }), 2000)
            } else {
              this.$refs.date.clearDate()
              this.$refs.form.resetFields()
              this.$router.replace('/promotion/add')
              this.type = 'add'
              this.id = ''
              this.submitted = false
              this.next = false
            }
          }
        } else {
          this.$message.error('请填写完整信息！')
          this.verifying = false
          return false
        }
      })
    }
  },
  async created () {
    const { type, id = '' } = this.$route.params
    this.platform = this.$route.meta.platform
    this.type = type
    this.id = id
    this.loading = true
    if (this.platform === 'agency') this.getAdUsers()
    else if (this.user.equal_to_account) this.handleAdUserChange(this.user.equal_to_account)

    if (this.id) {
      const [err, res] = await this['promotion/getPromotionDetail']({ id: this.id })
      if (err) this.$message.error('获取推广信息失败！')
      else {
        // eslint-disable-next-line camelcase
        const { advertiser_id, name, app_id, app_name, total_budget, budget, bidding, payment, is_all_time, times, date } = res.data
        this.originalPromotionName = name
        this.form = Object.assign({}, this.form, {
          advertiser_id,
          name,
          app_id,
          app_name,
          total_budget: comdify(total_budget), // this.type !== 'copy' ? orderName : `${orderName}_${+new Date()}`,
          budget: comdify(budget),
          bidding,
          payment,
          is_all_time,
          date,
          times
        })

        this.receiveDate = this.type !== 'copy' ? times : []
        this.receiveData = this.type !== 'copy' ? dataFilter(times) : []
        this.receiveDateRange = this.type !== 'copy' ? availableDate(date) : []

        if (this.platform === 'agency') this.handleAdUserChange(advertiser_id)
      }
    }
    this.loading = false
  }
}
</script>

<style lang="scss">
  @include b(app-promotion) {
    .icon-iconfontquestion {
      color: #fc8675;
    }

    @include e(bidding) {
      color: #e21d25;
    }

    @include e(app-item) {
      display: flex;
      align-items: center;
      height: 100%;
      img {
        margin-right: 5px;
        width: 24px;
        height: 24px;
      }
    }
  }
</style>
